import { connect } from 'react-redux';
import { selectLocaleData } from 'selectors/locale-data';
import DayOfWeekPicker from './DayOfWeekPicker';

export const mapStateToProps = (state, ownProps) => {
  const { startWeekOn } = selectLocaleData(state);

  return {
    ...ownProps,
    startWeekOn,
  };
};

export default connect(mapStateToProps)(DayOfWeekPicker);
